module.exports = {
  HOST: '/api',
  IS_PROD: false,
  IS_CRS: false,
  IS_DEBUG: true,
  IS_EDO: false,
  VERSION: '4.0.6',
  language: 'de',
  TABLE_SHRINK_HEIGHT: 0
}



// WEBPACK FOOTER //
// ./src/config.js